import * as React from 'react'

const HealthCheck = () => {
  return <div>Health success</div>
}
export default HealthCheck
